import { nanoid } from 'nanoid';
import mqttStore from 'store/mqttStore';

export function isBuilderFunctionEnabled() {
  try {
    return localStorage.getItem('kailab:virtualViewer') === 'threejs';
  } catch (error) {
    return false;
  }
}

// Executed in the UI, so a compiled/saved program cannot bypass the live setting.
export function publishBuilderFunction(functionName, classRoomCode) {
  if (!isBuilderFunctionEnabled()) throw new Error('Call builder function requires Three.js.');
  if (typeof functionName !== 'string') throw new Error('Builder function name must be a string.');
  const name = functionName.trim();
  if (!name || name.length > 64) throw new Error('Builder function name must contain 1 to 64 characters.');
  if (!classRoomCode) throw new Error('No current classroom.');
  if (!mqttStore.isConnected()) throw new Error('MQTT is disconnected.');
  return new Promise((resolve, reject) => {
    mqttStore.publish(`to/classroom/${classRoomCode}/builderFunction`, JSON.stringify({
      type: 'builderFunction',
      version: 1,
      id: nanoid(),
      functionName: name,
    }), { retain: false }, error => (error ? reject(error) : resolve()));
  });
}
